// Search titles (60 characters or fewer) and meta descriptions (160 or fewer)
// per route. Keys have no trailing slash. components/SEO.jsx uses these in
// preference to the props a page passes. Blog post titles longer than 60
// characters get a short search title in BLOG_SEO_TITLES.

export const ROUTE_SEO = {
  "/": {
    title: "Website Development Company India, USA & Dubai | Grotech",
    description: "Grotech Web builds fast, SEO-ready websites that bring enquiries, for businesses in India, the USA and Dubai. Websites from ₹25,000, $999 or AED 3,499.",
  },
  "/services": {
    title: "Website, SEO, Shopify & AI Services | Grotech Web",
    description: "All Grotech Web services: website development, SEO, Shopify stores, AI chatbots and automation, by country, city and industry, for India, USA and UAE.",
  },
  "/pricing": {
    title: "Website Development Pricing: India, USA & UAE | Grotech",
    description: "Websites from ₹25,000 in India, $999 in the USA and AED 3,499 in the UAE, plus optional monthly SEO and growth plans. Get a fixed quote in your currency.",
  },
  "/contact": {
    title: "Contact Grotech Web | Get a Free Website Plan",
    description: "Message Grotech Web on WhatsApp or call +91 98217 71460 for a free website plan and fixed quote. Serving businesses in India, the USA and the UAE.",
  },
  "/about": {
    title: "About Grotech Web | Founded by Somil Grover",
    description: "Grotech Web is a website development and SEO company founded by Somil Grover, who has 15+ years of web experience, serving India, the USA and the UAE.",
  },
  "/projects": {
    title: "Website Projects & Case Studies | Grotech Web",
    description: "Websites Grotech Web has built for e-commerce agencies, salons, hair clinics, pet shops and fashion brands, and the strategy behind each one.",
  },
  "/reviews": {
    title: "Grotech Web Reviews from India & USA Clients",
    description: "Client testimonials about Grotech Web's website development, SEO, Shopify and AI chatbot work for businesses in India and the USA.",
  },
  "/blog": {
    title: "Website, SEO & Lead Generation Insights | Grotech Web",
    description: "Practical guides for business owners on website costs, SEO, lead generation, Shopify and AI chatbots, for India, the USA and Dubai.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | Grotech Web",
    description: "How Grotech Web collects, uses and protects information shared through this website, enquiry forms, WhatsApp and analytics.",
  },
  "/terms": {
    title: "Terms of Service | Grotech Web",
    description: "Terms for using the Grotech Web website and for website development, SEO and related services provided by Grotech Web.",
  },

  // Services
  "/website-development": {
    title: "Website Development Services for Business | Grotech Web",
    description: "Custom, fast, SEO-ready business websites built to generate enquiries. Website development for India, the USA and Dubai, from ₹25,000 / $999 / AED 3,499.",
  },
  "/business-website-development": {
    title: "Business Website Development | Grotech Web",
    description: "Professional websites for companies and service providers that need to look credible and turn visitors into calls, WhatsApp chats and enquiries.",
  },
  "/website-design": {
    title: "Website Design Services: Modern & Conversion-Led | Grotech",
    description: "Premium website design that builds trust in seconds and guides visitors to enquire. Mobile-first layouts for businesses in India, the USA and the UAE.",
  },
  "/lead-generation-websites": {
    title: "Lead Generation Website Development | Grotech Web",
    description: "Websites designed backwards from the enquiry: clear offers, trust, forms and WhatsApp in the right places, and tracking on every lead.",
  },
  "/b2b-lead-generation-websites": {
    title: "B2B Lead Generation Websites | Grotech Web",
    description: "Websites that turn B2B buyers into qualified enquiries: capability pages, industry proof and multi-point lead capture for manufacturers and suppliers.",
  },
  "/b2b-website-development": {
    title: "B2B Website Development for Manufacturers | Grotech Web",
    description: "B2B website development for manufacturers, exporters and suppliers: product catalogues, capability pages and enquiry forms procurement teams trust.",
  },
  "/seo-friendly-websites": {
    title: "SEO-Friendly Website Development | Grotech Web",
    description: "Websites built for Google from day one: clean structure, fast pages, schema, internal links and content mapped to what your customers search.",
  },
  "/local-seo-websites": {
    title: "Local SEO Websites: Rank in Your City | Grotech Web",
    description: "Websites with location pages and Google Business Profile support, built to rank for near-me and city searches and bring local enquiries.",
  },
  "/website-redesign": {
    title: "Website Redesign Services | Grotech Web",
    description: "Redesign an outdated or slow website into a fast, modern, SEO-ready site that converts, while keeping your rankings with proper redirects.",
  },
  "/landing-page-design": {
    title: "Landing Page Design for Ads & Campaigns | Grotech Web",
    description: "High-converting landing pages for Google Ads, Meta ads and campaigns, with one clear offer, fast load times and lead capture built in.",
  },
  "/monthly-seo-growth": {
    title: "Monthly SEO & Website Growth Plans | Grotech Web",
    description: "Monthly SEO, new pages, articles and conversion improvements from ₹10,000, $299 or AED 999 a month, so your website brings more enquiries over time.",
  },
  "/seo-services": {
    title: "SEO Services for Small Businesses | Grotech Web",
    description: "Technical SEO, local SEO, content and on-page optimisation with honest timelines, for businesses in India, the USA and Dubai.",
  },
  "/shopify-website-development": {
    title: "Shopify Website Development Services | Grotech Web",
    description: "Custom Shopify stores with conversion-focused product pages, payments and shipping set up, for brands in India, the USA and the UAE.",
  },
  "/shopify-seo": {
    title: "Shopify SEO Services: More Organic Orders | Grotech Web",
    description: "Shopify SEO that fixes technical issues, product and collection pages and content, so your store gets more organic traffic and orders.",
  },
  "/ai-chatbot-development": {
    title: "AI Chatbot Development for Business Websites | Grotech",
    description: "AI chatbots trained on your business that answer customers 24/7 on your website and WhatsApp, qualify leads and hand off to your team.",
  },
  "/ai-business-automation": {
    title: "AI Business Automation Services | Grotech Web",
    description: "Automate lead replies, follow-ups, CRM updates and repetitive support with AI, so your team spends time on customers, not admin.",
  },
  "/ecommerce-website-development": {
    title: "E-commerce Website Development | Grotech Web",
    description: "E-commerce websites built to sell: fast product pages, smooth checkout, payments and shipping, on Shopify or a custom build.",
  },

  // Countries
  "/website-development-india": {
    title: "Website Development Company in India | Grotech Web",
    description: "Affordable premium business websites in India with SEO and WhatsApp lead capture built in. From ₹25,000, serving Mumbai, Delhi NCR and all of India.",
  },
  "/website-development-usa": {
    title: "Website Development Company for US Businesses | Grotech",
    description: "Custom, SEO-ready websites for US small businesses from $999, a fraction of typical US agency rates, with calls scheduled in your time zone.",
  },
  "/website-development-dubai": {
    title: "Website Development Company in Dubai & UAE | Grotech Web",
    description: "Fast, SEO-ready, English and Arabic-ready websites for Dubai and UAE businesses with WhatsApp lead capture, from AED 3,499.",
  },
  "/seo-services-india": {
    title: "SEO Services in India for Businesses | Grotech Web",
    description: "Honest SEO services in India: technical SEO, local SEO and content that brings enquiries, with monthly plans from ₹10,000.",
  },
  "/seo-services-usa": {
    title: "SEO Services for US Small Businesses | Grotech Web",
    description: "Affordable SEO for US small businesses: technical SEO, content and local search, with monthly plans from $299 and transparent reporting.",
  },
  "/seo-services-dubai": {
    title: "SEO Services in Dubai for Small Businesses | Grotech Web",
    description: "SEO for Dubai and UAE businesses: technical SEO, Google Business Profile, English and Arabic content, with monthly plans from AED 999.",
  },
  "/shopify-development-india": {
    title: "Shopify Development Company in India | Grotech Web",
    description: "Shopify stores for Indian D2C brands with UPI, COD and shipping set up and product pages built to convert, at Indian-market pricing.",
  },
  "/shopify-development-usa": {
    title: "Shopify Development Company for US Stores | Grotech Web",
    description: "Custom Shopify store design and development for US brands, with conversion-focused product pages and speed optimisation, from $999.",
  },
  "/shopify-development-dubai": {
    title: "Shopify Store Development in Dubai & UAE | Grotech Web",
    description: "Shopify stores for Dubai and UAE brands with AED pricing, VAT, UAE payments and shipping set up and pages built to convert, from AED 3,499.",
  },
  "/ai-chatbot-development-india": {
    title: "AI Chatbot Development Company in India | Grotech Web",
    description: "WhatsApp and website AI chatbots for Indian businesses that answer customers instantly, qualify leads and capture enquiries 24/7.",
  },
  "/ai-chatbot-development-usa": {
    title: "AI Chatbot Development for US Businesses | Grotech Web",
    description: "Custom AI chatbots for US businesses, trained on your services, that answer questions and capture leads around the clock.",
  },
  "/ai-automation-india": {
    title: "AI Automation Company in India | Grotech Web",
    description: "AI automation for Indian businesses: instant WhatsApp replies, automatic follow-ups and CRM workflows that capture every enquiry.",
  },
  "/ai-automation-usa": {
    title: "AI Automation Agency for US Small Businesses | Grotech",
    description: "AI automation for US small businesses: lead follow-up, scheduling, CRM and support workflows that save hours every week.",
  },

  // Cities
  "/website-development-mumbai": {
    title: "Website Development Company in Mumbai | Grotech Web",
    description: "Business websites for Mumbai companies: fast, SEO-ready and built to bring enquiries from Google and WhatsApp. From ₹25,000.",
  },
  "/website-development-delhi": {
    title: "Website Development Company in Delhi | Grotech Web",
    description: "Business websites for Delhi companies that rank on Google and turn visitors into calls and WhatsApp enquiries. From ₹25,000.",
  },
  "/website-development-noida": {
    title: "Website Development Company in Noida | Grotech Web",
    description: "Websites for Noida businesses, from manufacturers to salons and clinics, built to rank locally and generate enquiries. From ₹25,000.",
  },
  "/website-development-gurgaon": {
    title: "Website Development Company in Gurgaon | Grotech Web",
    description: "Business websites for Gurgaon companies and startups: premium design, SEO foundation and lead capture built in. From ₹25,000.",
  },

  // Industries
  "/website-development-for-manufacturers": {
    title: "Website Development for Manufacturers | Grotech Web",
    description: "Websites for manufacturers and exporters with product catalogues, capability pages and RFQ forms that turn buyers into enquiries.",
  },
  "/website-development-for-consultants": {
    title: "Website Development for Consultants | Grotech Web",
    description: "Websites for consultants and professional firms that build authority, explain your expertise and book more discovery calls.",
  },
  "/website-development-for-real-estate": {
    title: "Real Estate Website Development | Grotech Web",
    description: "Real estate websites with project pages, enquiry forms and WhatsApp built in, designed to capture buyer and investor leads.",
  },
  "/website-development-for-startups": {
    title: "Website Development for Startups | Grotech Web",
    description: "Fast, credible startup websites that explain your product, win early customers and investors, and grow with you.",
  },
  "/website-development-for-small-business": {
    title: "Small Business Website Development | Grotech Web",
    description: "Affordable, professional small business websites that look premium, rank on Google and bring customers. From ₹25,000 / $999 / AED 3,499.",
  },
};

export const BLOG_SEO_TITLES = {
  "ai-search-optimization": "AI Search Optimization: Prepare Your Business",
  "website-vs-social-media": "Website vs Social Media: Why You Still Need a Website",
  "website-speed-seo-performance": "Website Speed and SEO: Why Performance Matters",
  "noida-businesses-website-24-7-salesperson": "Turn Your Noida Business Website Into a 24/7 Salesperson",
  "website-growth-strategies-delhi-ncr": "Website Growth Strategies for Delhi NCR Businesses",
  "seo-for-mumbai-businesses-rank-on-google": "SEO for Mumbai Businesses: How to Rank on Google",
  "how-long-does-seo-take-delhi-ncr": "How Long Does SEO Take in Delhi NCR? Realistic Timeline",
  "noida-manufacturers-generate-b2b-leads-website": "B2B Lead Generation Websites for Noida Manufacturers",
  "website-lead-generation-mumbai-service-businesses": "Website Lead Generation for Mumbai Service Businesses",
  "b2b-marketing-delhi-ncr-website-best-salesperson": "B2B Marketing in Delhi NCR: Your Website as Salesperson",
  "mumbai-b2b-companies-lead-generation-website": "How Mumbai B2B Companies Win Clients With Their Website",
  "business-website-design-guide-noida-2026": "Business Website Design Guide for Noida (2026)",
  "website-design-mistakes-delhi-businesses": "7 Website Design Mistakes Costing Delhi Businesses",
  "local-seo-noida-rank-near-me-searches": "Local SEO in Noida: Rank for 'Near Me' Searches",
  "local-seo-mumbai-win-your-area": "Local SEO for Mumbai Businesses: Win Your Area First",
  "delhi-ncr-businesses-grow-online-small-budget": "Grow Online in Delhi NCR Without a Big Budget",
  "mumbai-business-website-growth-roadmap": "Website Growth Roadmap for Mumbai Businesses",
  "gym-website-delhi-ncr-high-converting": "Gym & Fitness Studio Websites That Convert (Delhi NCR)",
  "doctor-clinic-website-mumbai-appointments": "Clinic Websites That Fill Appointments in Mumbai",
  "website-not-generating-business-enquiries": "Website Not Generating Enquiries? A 10-Minute Diagnostic",
  "what-to-look-for-website-developer-noida": "What to Look for in a Website Developer in Noida",
  "business-website-cost-usa": "How Much Does a Business Website Cost in the USA?",
  "ai-chatbot-small-business": "AI Chatbots for Small Businesses: What They Do in 2026",
};

// Meta descriptions for posts whose excerpt is over 160 characters.
export const BLOG_SEO_DESCRIPTIONS = {
  "website-growth-strategies-delhi-ncr": "Practical website growth strategies for Delhi NCR businesses: local SEO, clear offers, WhatsApp and pages that turn visitors into enquiries.",
  "seo-for-mumbai-businesses-rank-on-google": "How Mumbai businesses can rank on Google in a crowded market: local SEO, service pages, Google Business Profile and content that wins.",
  "how-long-does-seo-take-delhi-ncr": "A realistic SEO timeline for Delhi NCR businesses: what moves in weeks, what takes months, and how to see progress early.",
  "noida-manufacturers-generate-b2b-leads-website": "How Noida manufacturers can win B2B buyers online: capability pages, product catalogues, RFQ forms and SEO that procurement teams find.",
  "website-lead-generation-mumbai-service-businesses": "A practical playbook for Mumbai service businesses to turn website visitors into calls, WhatsApp chats and booked jobs.",
  "b2b-marketing-delhi-ncr-website-best-salesperson": "Why the website is the best salesperson for Delhi NCR B2B companies, and how to structure it to win shortlists and RFQs.",
  "mumbai-b2b-companies-lead-generation-website": "How Mumbai B2B companies can use a lead-generation website to reach decision-makers and win new clients.",
  "business-website-design-guide-noida-2026": "What a great business website design looks like in 2026, for Noida business owners: speed, trust, mobile layout and clear calls to action.",
  "local-seo-noida-rank-near-me-searches": "How Noida businesses can rank for 'near me' searches with Google Business Profile, location pages and reviews.",
  "mumbai-business-website-growth-roadmap": "A step-by-step roadmap for Mumbai businesses to go from invisible online to a website that brings steady enquiries.",
  "doctor-clinic-website-mumbai-appointments": "How doctors and clinics in Mumbai can build a website that earns patient trust and fills appointment slots.",
  "website-development-small-business-guide": "The complete guide to website development for small businesses: costs, pages, SEO, timelines and how to choose a developer.",
  "website-development-cost-mumbai": "What website development costs in Mumbai, what drives the price, and how to get a website that pays for itself.",
  "lead-generation-website-b2b-business": "How a lead-generation website helps a B2B business attract buyers, qualify enquiries and shorten the sales cycle.",
  "business-website-cost-usa": "What a business website costs in the USA in 2026, from DIY builders to agencies, and how to get a premium site for less.",
};
